export const AttackTrailStateEnum = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  MITIGATED: 'mitigated',
  REOPENED: 'reopened',
  properties: {
    active: {
      title: 'Active',
      state: 'ACTIVE',
      routeName: 'active-cyber-attacks'
    },
    inactive: {
      title: 'Inactive',
      state: 'INACTIVE',
      routeName: 'inactive-cyber-attacks'
    },
    mitigated: {
      title: 'Mitigated',
      state: 'MITIGATED',
      routeName: 'mitigated-cyber-attacks'
    },
    reopened: {
      title: 'Reopened',
      state: 'REOPENED',
      routeName: 'reopened-cyber-attacks'
    }
  }
}



// WEBPACK FOOTER //
// ./src/constants/trail-state.constants.js